import { render } from "./HomeHome.vue?vue&type=template&id=caf904ae&scoped=true"
import script from "./HomeHome.vue?vue&type=script&lang=js"
export * from "./HomeHome.vue?vue&type=script&lang=js"

import "./HomeHome.vue?vue&type=style&index=0&id=caf904ae&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf904ae"]])

export default __exports__